import { Node } from '@alfresco/js-api';
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  ViewChild,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { WkFileUploadComponent } from '../../dialogs/wk-file-upload/wk-file-upload.component';
import { SiteConfigService } from '../../services/site-config.service';
import { FileModel } from '@alfresco/adf-content-services';

@Component({
  selector: 'wk-upload-files-list',
  templateUrl: './wk-upload-files-list.component.html',
  styleUrls: ['./wk-upload-files-list.component.scss'],
  standalone: false,
})
export class WkUploadFilesListComponent implements OnChanges {
  @Input() fileNamesToUpload: string[];
  @Input() directoryName;
  @Input() files: FileModel[];
  @Input() documentType: any;
  @ViewChild('currentDropDownSelection') currentDropDownSelection: ElementRef;
  currentSelection;
  currSiteObj;
  siteObject;
  currentDropDownTypes = [];
  constructor(
    private readonly dialogRef: MatDialogRef<WkFileUploadComponent>,
    private readonly siteAppConfig: SiteConfigService
  ) {}

  ngOnChanges() {
    const currentSite = localStorage.getItem('currentSite');
    this.updateArrays(currentSite, this.directoryName);
  }

  updateArrays(currentSite: string, dirName: Node) {
    this.currentDropDownTypes = this.siteAppConfig.getFolderObject(
      currentSite,
      dirName
    );
  }

  deleteFile(index: number) {
    this.fileNamesToUpload.splice(index, 1);
    this.files.splice(index, 1);
    if (this.fileNamesToUpload.length === 0) {
      this.dialogRef.close({ uploadQueue: false });
    }
  }
}
